import { render, staticRenderFns } from "./itemDialog.vue?vue&type=template&id=b74313b8&scoped=true"
import script from "./itemDialog.vue?vue&type=script&lang=js"
export * from "./itemDialog.vue?vue&type=script&lang=js"
import style0 from "./itemDialog.vue?vue&type=style&index=0&id=b74313b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74313b8",
  null
  
)

export default component.exports